import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Row, Col, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { sk } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import { fetchEntryYears, exportOperationalLogToPdf } from '../../store/actions/operationalLog';

const MONTH_LABELS = ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December'];
const QUARTER_LABELS = ['Q1 (Jan – Mar)', 'Q2 (Apr – Jún)', 'Q3 (Júl – Sep)', 'Q4 (Okt – Dec)'];

const ExportOperationalLogToPdf = ({ operationalLogId, name, onClose }) => {
    const dispatch = useDispatch();
    const currentYear = new Date().getFullYear();

    const [years, setYears] = useState([currentYear]);

    useEffect(() => {
        dispatch(fetchEntryYears({ operationalLogId })).unwrap()
            .then((data) => { if (data.length > 0) setYears(data); })
            .catch(() => {});
    }, [dispatch, operationalLogId]);

    const [mode, setMode] = useState('month');
    const [year, setYear] = useState(currentYear);

    useEffect(() => { setYear(years[0]); }, [years]);
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [quarter, setQuarter] = useState(Math.ceil((new Date().getMonth() + 1) / 3));
    const [day, setDay] = useState(new Date());

    const handleExport = () => {
        const params = { operationalLogId, name, year };
        if (mode === 'day') {
            params.month = day.getMonth() + 1;
            params.day = day.getDate();
            params.year = day.getFullYear();
        } else if (mode === 'quarter') {
            params.quarter = quarter;
        } else if (mode === 'month') {
            params.month = month;
        }
        dispatch(exportOperationalLogToPdf(params));
        onClose();
    };

    return (
        <Form>
            <h2>Exportovať denník do PDF</h2>
            <hr />

            <Form.Group className="mb-3">
                <Form.Label>Rozsah exportu</Form.Label>
                <div className="d-flex gap-3">
                    {[
                        { value: 'day', label: 'Jeden deň' },
                        { value: 'month', label: 'Mesiac' },
                        { value: 'quarter', label: 'Kvartál' },
                        { value: 'year', label: 'Celý rok' },
                    ].map(({ value, label }) => (
                        <Form.Check
                            key={value}
                            type="radio"
                            id={`mode-${value}`}
                            label={label}
                            checked={mode === value}
                            onChange={() => setMode(value)}
                        />
                    ))}
                </div>
            </Form.Group>

            {mode === 'day' && (
                <Form.Group className="mb-3">
                    <Form.Label>Dátum</Form.Label>
                    <div>
                        <DatePicker
                            selected={day}
                            onChange={(date) => setDay(date)}
                            dateFormat="dd.MM.yyyy"
                            className="form-control"
                            locale={sk}
                        />
                    </div>
                </Form.Group>
            )}

            {mode !== 'day' && (
                <Row>
                    <Col xs={12} md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Rok</Form.Label>
                            <Form.Select value={year} onChange={(e) => setYear(Number(e.target.value))}>
                                {years.map((y) => (
                                    <option key={y} value={y}>{y}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {mode === 'month' && (
                        <Col xs={12} md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Mesiac</Form.Label>
                                <Form.Select value={month} onChange={(e) => setMonth(Number(e.target.value))}>
                                    {MONTH_LABELS.map((label, index) => (
                                        <option key={label} value={index + 1}>{label}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    )}
                    {mode === 'quarter' && (
                        <Col xs={12} md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Kvartál</Form.Label>
                                <Form.Select value={quarter} onChange={(e) => setQuarter(Number(e.target.value))}>
                                    {QUARTER_LABELS.map((label, index) => (
                                        <option key={label} value={index + 1}>{label}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    )}
                </Row>
            )}

            <Row>
                <Col className="d-flex justify-content-end">
                    <Button
                        className="button-custom-large"
                        variant="primary"
                        type="button"
                        onClick={handleExport}
                    >
                        Exportovať do PDF
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};

export default ExportOperationalLogToPdf;
